// extracted by mini-css-extract-plugin
export default {"sendGift":"__iMvx61F2NCXIdfHWFA","report":"yLwgWpxjzS4Kmy_It5Hg"};